<template>
  <div class="calendar">
    <div class="left">
      <el-row :gutter="8" style="margin-top: 10px;" type="flex" align="middle" justify="center">
        <el-col :span="6">
          <span class="tag">素材类型:</span>
          <!--
          <el-select v-model="filterData.type" placeholder="" clearable>
            <el-option
              v-for="(item, index) in typeList"
              :key="index"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>-->
        </el-col>
        <el-col :span="18" v-show="filterData.type === 2">
          <el-select v-model="filterData.categoryIds" placeholder="" multiple clearable>
            <el-option
              v-for="(item, index) in categoryList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <div style="margin-top: 15px;">
        <el-input placeholder="搜索素材文件夹名称" v-model="filterData.name" class="search">
          <el-button slot="append" icon="el-icon-search" @click="searchList()"></el-button>
        </el-input>
      </div>

      <ul class="courseList">
        <li v-for="course in courseList" draggable @dragend="dragEnd($event, course)">
          {{ course.name }} id:{{ course.courseId }}
        </li>
      </ul>
    </div>
    <div class="right">
      <div class="tabs">
        <el-tabs v-model="activeName">
          <el-tab-pane label="素材日历" name="first"></el-tab-pane>
          <el-tab-pane label="季度安排日历" name="second"></el-tab-pane>
        </el-tabs>
      </div>
      <div v-if="activeName === 'first'">
        <full-calendar
          :events="fcEvents"
          locale="en"
          @dayClick="dayClick"
          @changeMonth="changeMonth"
          @deleteClick="deleteClick"
        >
        </full-calendar>
      </div>
      <div v-if="activeName === 'second'">
        <div>
          <el-button @click="setMaterialType" size="small">素材类型设置</el-button>
          <el-button @click="importData()" size="small">上传excel</el-button>
        </div>
        <div class="season-calendar-container">
          <div class="season-calendar">
            <div class="month">
              <ul>
                <li>July 2023</li>
                <li>August 2023</li>
                <li>September 2023</li>
              </ul>
            </div>
            <div class="week">
              <ul>
                <li>
                  <div class="week-title">
                    7.3-7.9
                  </div>
                  <div class="sub-week-title">
                    RETAIL MOMENT
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      OOTD
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>@WO PHOTO SHOOTING</span>
                        <span class="material">SU FLOW1 @WO OOTD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>拍立学#FOLLOW</span>
                        <span class="material">SU23 STREET DANCE PHASE1<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>其他素材</span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      BRAND
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>SBM</span>
                        <span class="material">FREAK 5<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>VMS</span>
                        <span class="material">GRASSROOTS SUMMER HOLD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="bottom-table">
                    <span class="title">本周微信群/OA推文主题及素材使用建议</span>
                    <span>#假期出游穿搭</span>
                    <span>#Freak 5</span>
                    <span>(@wo/品牌素材)</span>
                    <span @click="addSuggestion" class="add">+添加建议</span>
                  </div>
                </li>
                <li>
                  <div class="week-title">
                    7.10-7.16
                  </div>
                  <div class="sub-week-title">
                    RETAIL MOMENT
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      OOTD
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>@WO PHOTO SHOOTING</span>
                        <span class="material">SU FLOW1 @WO OOTD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>拍立学#FOLLOW</span>
                        <span class="material">SU23 STREET DANCE PHASE1<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>其他素材</span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      BRAND
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>SBM</span>
                        <span class="material">FREAK 5<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>VMS</span>
                        <span class="material">GRASSROOTS SUMMER HOLD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="bottom-table">
                    <span class="title">本周微信群/OA推文主题及素材使用建议</span>
                    <span>#假期出游穿搭</span>
                    <span>#Freak 5</span>
                    <span>(@wo/品牌素材)</span>
                    <span @click="addSuggestion" class="add">+添加建议</span>
                  </div>
                </li>
                <li>
                  <div class="week-title">
                    7.17-7.23
                  </div>
                  <div class="sub-week-title">
                    RETAIL MOMENT
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      OOTD
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>@WO PHOTO SHOOTING</span>
                        <span class="material">SU FLOW1 @WO OOTD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>拍立学#FOLLOW</span>
                        <span class="material">SU23 STREET DANCE PHASE1<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>其他素材</span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      BRAND
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>SBM</span>
                        <span class="material">FREAK 5<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>VMS</span>
                        <span class="material">GRASSROOTS SUMMER HOLD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="bottom-table">
                    <span class="title">本周微信群/OA推文主题及素材使用建议</span>
                    <span>#假期出游穿搭</span>
                    <span>#Freak 5</span>
                    <span>(@wo/品牌素材)</span>
                    <span @click="addSuggestion" class="add">+添加建议</span>
                  </div>
                </li>
                <li>
                  <div class="week-title">
                    7.24-7.30
                  </div>
                  <div class="sub-week-title">
                    RETAIL MOMENT
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      OOTD
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>@WO PHOTO SHOOTING</span>
                        <span class="material">SU FLOW1 @WO OOTD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>拍立学#FOLLOW</span>
                        <span class="material">SU23 STREET DANCE PHASE1<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>其他素材</span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      BRAND
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>SBM</span>
                        <span class="material">FREAK 5<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>VMS</span>
                        <span class="material">GRASSROOTS SUMMER HOLD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="bottom-table">
                    <span class="title">本周微信群/OA推文主题及素材使用建议</span>
                    <span>#假期出游穿搭</span>
                    <span>#Freak 5</span>
                    <span>(@wo/品牌素材)</span>
                    <span @click="addSuggestion" class="add">+添加建议</span>
                  </div>
                </li>
                <li>
                  <div class="week-title">
                    7.31-8.6
                  </div>
                  <div class="sub-week-title">
                    RETAIL MOMENT
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      OOTD
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>@WO PHOTO SHOOTING</span>
                        <span class="material">SU FLOW1 @WO OOTD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>拍立学#FOLLOW</span>
                        <span class="material">SU23 STREET DANCE PHASE1<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>其他素材</span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      BRAND
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>SBM</span>
                        <span class="material">FREAK 5<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>VMS</span>
                        <span class="material">GRASSROOTS SUMMER HOLD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="bottom-table">
                    <span class="title">本周微信群/OA推文主题及素材使用建议</span>
                    <span>#假期出游穿搭</span>
                    <span>#Freak 5</span>
                    <span>(@wo/品牌素材)</span>
                    <span @click="addSuggestion" class="add">+添加建议</span>
                  </div>
                </li>
                <li>
                  <div class="week-title">
                    8.7-8.13
                  </div>
                  <div class="sub-week-title">
                    RETAIL MOMENT
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      OOTD
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>@WO PHOTO SHOOTING</span>
                        <span class="material">SU FLOW1 @WO OOTD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>拍立学#FOLLOW</span>
                        <span class="material">SU23 STREET DANCE PHASE1<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>其他素材</span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      BRAND
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>SBM</span>
                        <span class="material">FREAK 5<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>VMS</span>
                        <span class="material">GRASSROOTS SUMMER HOLD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="bottom-table">
                    <span class="title">本周微信群/OA推文主题及素材使用建议</span>
                    <span>#假期出游穿搭</span>
                    <span>#Freak 5</span>
                    <span>(@wo/品牌素材)</span>
                    <span @click="addSuggestion" class="add">+添加建议</span>
                  </div>
                </li>
                <li>
                  <div class="week-title">
                    8.14-8.20
                  </div>
                  <div class="sub-week-title">
                    RETAIL MOMENT
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      OOTD
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>@WO PHOTO SHOOTING</span>
                        <span class="material">SU FLOW1 @WO OOTD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>拍立学#FOLLOW</span>
                        <span class="material">SU23 STREET DANCE PHASE1<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>其他素材</span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      BRAND
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>SBM</span>
                        <span class="material">FREAK 5<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>VMS</span>
                        <span class="material">GRASSROOTS SUMMER HOLD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="bottom-table">
                    <span class="title">本周微信群/OA推文主题及素材使用建议</span>
                    <span>#假期出游穿搭</span>
                    <span>#Freak 5</span>
                    <span>(@wo/品牌素材)</span>
                    <span @click="addSuggestion" class="add">+添加建议</span>
                  </div>
                </li>
                <li>
                  <div class="week-title">
                    8.21-8.27
                  </div>
                  <div class="sub-week-title">
                    RETAIL MOMENT
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      OOTD
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>@WO PHOTO SHOOTING</span>
                        <span class="material">SU FLOW1 @WO OOTD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>拍立学#FOLLOW</span>
                        <span class="material">SU23 STREET DANCE PHASE1<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>其他素材</span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      BRAND
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>SBM</span>
                        <span class="material">FREAK 5<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>VMS</span>
                        <span class="material">GRASSROOTS SUMMER HOLD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="bottom-table">
                    <span class="title">本周微信群/OA推文主题及素材使用建议</span>
                    <span>#假期出游穿搭</span>
                    <span>#Freak 5</span>
                    <span>(@wo/品牌素材)</span>
                    <span @click="addSuggestion" class="add">+添加建议</span>
                  </div>
                </li>
                <li>
                  <div class="week-title">
                    8.29-9.3
                  </div>
                  <div class="sub-week-title">
                    RETAIL MOMENT
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      OOTD
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>@WO PHOTO SHOOTING</span>
                        <span class="material">SU FLOW1 @WO OOTD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>拍立学#FOLLOW</span>
                        <span class="material">SU23 STREET DANCE PHASE1<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>其他素材</span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      BRAND
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>SBM</span>
                        <span class="material">FREAK 5<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>VMS</span>
                        <span class="material">GRASSROOTS SUMMER HOLD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="bottom-table">
                    <span class="title">本周微信群/OA推文主题及素材使用建议</span>
                    <span>#假期出游穿搭</span>
                    <span>#Freak 5</span>
                    <span>(@wo/品牌素材)</span>
                    <span @click="addSuggestion" class="add">+添加建议</span>
                  </div>
                </li>
                <li>
                  <div class="week-title">
                    9.3-9.10
                  </div>
                  <div class="sub-week-title">
                    RETAIL MOMENT
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      OOTD
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>@WO PHOTO SHOOTING</span>
                        <span class="material">SU FLOW1 @WO OOTD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>拍立学#FOLLOW</span>
                        <span class="material">SU23 STREET DANCE PHASE1<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>其他素材</span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      BRAND
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>SBM</span>
                        <span class="material">FREAK 5<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>VMS</span>
                        <span class="material">GRASSROOTS SUMMER HOLD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="bottom-table">
                    <span class="title">本周微信群/OA推文主题及素材使用建议</span>
                    <span>#假期出游穿搭</span>
                    <span>#Freak 5</span>
                    <span>(@wo/品牌素材)</span>
                    <span @click="addSuggestion" class="add">+添加建议</span>
                  </div>
                </li>
                <li>
                  <div class="week-title">
                    9.11-9.17
                  </div>
                  <div class="sub-week-title">
                    RETAIL MOMENT
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      OOTD
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>@WO PHOTO SHOOTING</span>
                        <span class="material">SU FLOW1 @WO OOTD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>拍立学#FOLLOW</span>
                        <span class="material">SU23 STREET DANCE PHASE1<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>其他素材</span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      BRAND
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>SBM</span>
                        <span class="material">FREAK 5<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>VMS</span>
                        <span class="material">GRASSROOTS SUMMER HOLD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="bottom-table">
                    <span class="title">本周微信群/OA推文主题及素材使用建议</span>
                    <span>#假期出游穿搭</span>
                    <span>#Freak 5</span>
                    <span>(@wo/品牌素材)</span>
                    <span @click="addSuggestion" class="add">+添加建议</span>
                  </div>
                </li>
                <li>
                  <div class="week-title">
                    9.18-9.24
                  </div>
                  <div class="sub-week-title">
                    RETAIL MOMENT
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      OOTD
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>@WO PHOTO SHOOTING</span>
                        <span class="material">SU FLOW1 @WO OOTD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>拍立学#FOLLOW</span>
                        <span class="material">SU23 STREET DANCE PHASE1<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>其他素材</span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      BRAND
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>SBM</span>
                        <span class="material">FREAK 5<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>VMS</span>
                        <span class="material">GRASSROOTS SUMMER HOLD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="bottom-table">
                    <span class="title">本周微信群/OA推文主题及素材使用建议</span>
                    <span>#假期出游穿搭</span>
                    <span>#Freak 5</span>
                    <span>(@wo/品牌素材)</span>
                    <span @click="addSuggestion" class="add">+添加建议</span>
                  </div>
                </li>
                <li>
                  <div class="week-title">
                    9.25-10.1
                  </div>
                  <div class="sub-week-title">
                    RETAIL MOMENT
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      OOTD
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>@WO PHOTO SHOOTING</span>
                        <span class="material">SU FLOW1 @WO OOTD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>拍立学#FOLLOW</span>
                        <span class="material">SU23 STREET DANCE PHASE1<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>其他素材</span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="table-content">
                    <div class="table-left">
                      BRAND
                      <br/>
                      ASSETS
                    </div>
                    <div class="table-right">
                      <div class="material-content">
                        <span>SBM</span>
                        <span class="material">FREAK 5<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                      <div class="material-content">
                        <span>VMS</span>
                        <span class="material">GRASSROOTS SUMMER HOLD<i @click="deleteMaterial">×</i></span>
                        <span @click="addMaterial">+添加素材</span>
                      </div>
                    </div>
                  </div>
                  <div class="bottom-table">
                    <span class="title">本周微信群/OA推文主题及素材使用建议</span>
                    <span>#假期出游穿搭</span>
                    <span>#Freak 5</span>
                    <span>(@wo/品牌素材)</span>
                    <span @click="addSuggestion" class="add">+添加建议</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="$t('calendar.setMaterialType')"
      :visible.sync="setMaterialTypeDialogVisible"
      width="50%"
    >
      <div class="categoryManageBox">
        <el-button
          type="success"
          icon="el-icon-plus"
          size="small"
          @click="openAdd(0, false)"
          style="margin-bottom: 20px"
        >
          添加大类
        </el-button>
        <el-tree
          :data="materialTypeData"
          node-key="id"
          default-expand-all
          :expand-on-click-node="false"
          :render-content="renderContent">
        </el-tree>
      </div>

      <el-dialog
        width="30%"
        :title="isEditMaterialType ? $t('calendar.editMaterialType') : $t('calendar.createMaterialType')"
        :visible.sync="editMaterialTypeVisible"
        append-to-body>
        <el-form
          :model="materialTypeForm"
          ref="materialTypeForm"
          label-width="100px"
        >
          <el-form-item :label="$t('calendar.categoryName')" prop="name">
            <el-input
              v-model="materialTypeForm.name"
              :placeholder="$t('calendar.enterCategoryName')"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <footer class="dialog-footer">
            <el-button type="primary" @click="saveCategory">{{ $t('confirm') }}</el-button>
            <el-button @click="editMaterialTypeVisible = false">{{ $t('cancel') }}</el-button>
          </footer>
        </el-form>
      </el-dialog>

      <footer slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveMaterialType">{{ $t('save') }}</el-button>
        <el-button @click="setMaterialTypeDialogVisible = false">{{ $t('cancel') }}</el-button>
      </footer>
    </el-dialog>

    <el-dialog
      :title="$t('calendar.addMaterial')"
      :visible.sync="addMaterialDialogVisible"
      width="50%"
    >
      <el-form
        :model="materialForm"
        ref="materialForm"
        label-width="100px"
      >
        <el-form-item :label="$t('calendar.month') + ':'" prop="month">
          {{ materialForm.month }}
        </el-form-item>
        <el-form-item :label="$t('calendar.week') + ':'" prop="week">
          {{ materialForm.week }}
        </el-form-item>
        <el-form-item :label="$t('calendar.bigCategory') + ':'" prop="bigCategory">
          {{ materialForm.bigCategory }}
        </el-form-item>
        <el-form-item :label="$t('calendar.sonCategory') + ':'" prop="sonCategory">
          {{ materialForm.sonCategory }}
        </el-form-item>
        <el-form-item :label="$t('calendar.materialType') + ':'" prop="type">
          <el-select v-model="materialForm.type" :placeholder="$t('calendar.chooseMaterialType')" style="width: 100%">
            <el-option
              v-for="item in materialTypeList"
              :key="item.itemKey"
              :label="item.itemValue"
              :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('calendar.materialFile') + ':'" prop="file">
          <el-select v-model="materialForm.file" :placeholder="$t('calendar.chooseMaterialFile')" style="width: 100%">
            <el-option
              v-for="item in materialFileList"
              :key="item.itemKey"
              :label="item.itemValue"
              :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <footer slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveMaterial">{{ $t('save') }}</el-button>
        <el-button @click="addMaterialDialogVisible = false">{{ $t('cancel') }}</el-button>
      </footer>
    </el-dialog>

    <el-dialog
      :title="$t('calendar.addSuggestion')"
      :visible.sync="addSuggestionDialogVisible"
      width="50%"
    >
      <el-form
        :model="suggestionForm"
        ref="suggestionForm"
        label-width="100px"
      >
        <el-form-item :label="$t('calendar.suggestionTheme') + '1:'" prop="theme1">
          <el-input v-model="suggestionForm.theme1" :placeholder="$t('calendar.enterTheme')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('calendar.suggestionTheme') + '2:'" prop="theme2">
          <el-input v-model="suggestionForm.theme2" :placeholder="$t('calendar.enterTheme')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('calendar.suggestionTheme') + '3:'" prop="theme3">
          <el-input v-model="suggestionForm.theme3" :placeholder="$t('calendar.enterTheme')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('calendar.suggestionOrigin') + ':'" prop="materialOrigin">
          <el-select v-model="suggestionForm.materialOrigin" :placeholder="$t('calendar.chooseMaterialOrigin')" style="width: 100%">
            <el-option
              v-for="item in materialOriginList"
              :key="item.itemKey"
              :label="item.itemValue"
              :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <footer slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveSuggestion">{{ $t('save') }}</el-button>
        <el-button @click="addSuggestionDialogVisible = false">{{ $t('cancel') }}</el-button>
      </footer>
    </el-dialog>
  </div>
</template>

<script>
  import fullCalendar from '../../components/calendar/fullCalendar.vue'

  const data = [{
    id: 1,
    label: '一级 1',
    children: [{
      id: 4,
      label: '二级 1-1',
      children: [{
        id: 9,
        label: '三级 1-1-1'
      }, {
        id: 10,
        label: '三级 1-1-2'
      }]
    }]
  }, {
    id: 2,
    label: '一级 2',
    children: [{
      id: 5,
      label: '二级 2-1'
    }, {
      id: 6,
      label: '二级 2-2'
    }]
  }, {
    id: 3,
    label: '一级 3',
    children: [{
      id: 7,
      label: '二级 3-1'
    }, {
      id: 8,
      label: '二级 3-2'
    }]
  }];

  export default {
    name: "calendar",
    data () {
      return {
        materialOriginList: [], // 素材来源列表
        addSuggestionDialogVisible: false,
        materialFileList: [], // 素材文件夹列表
        materialTypeList: [], // 素材类型列表
        materialForm: {
          month: '', // 月份
          week: '', // 周期
          bigCategory: '', // 大类型
          sonCategory: '', // 子类型
          materialType: '', // 素材类型
          materialFile: '', // 素材文件夹
        },
        suggestionForm: {
          theme1: '', // 主题一
          theme2: '', // 主题二
          theme3: '', // 主题三
          materialOrigin: '', // 素材来源
        },
        monthCalendar: [
          {
            date: '7.3-7.9',
            ootd: [
              {
                name: '@WO PHOTO SHOOTING',
                material: 'SU23 FLOW1 @WO OOTD'
              },
              {
                name: '拍力学#FOLLOW',
                material: 'SU23 STREET DANCE PHASE1'
              },
              {
                name: '其他素材',
                material: 'ISstyle FA23素材'
              },
            ],
            brand: [
              {
                name: 'SBM',
                material: 'Freak 5',
              },
              {
                name: 'VMS',
                material: 'GRASSROOTS SUMMER HOLD'
              }
            ],
            OA: [
              '#假期出游穿搭',
              '#Freak 5',
              '(@wo/品牌素材)'
            ]
          }
        ],
        initMaterialTypeForm: {
          name: '',
          parentId: 0
        },
        addMaterialDialogVisible: false,
        materialTypeForm: {},
        isEditMaterialType: false,
        materialTypeData: JSON.parse(JSON.stringify(data)),
        setMaterialTypeDialogVisible: false,
        editMaterialTypeVisible: false,
        activeName: 'first',
        fcEvents : [],
        // {title: "事件名", start: "2021-01-01", end: "2021-01-01"}
        filterData: {
          name: '', // 名称
          type: 2, // 课程/课程集
          categoryIds: [] //大类
        },
        currentCourse: {},
        curDate: '',
        currentStart: '', // 当前日历月份的第一天,用于请求日历显示月份的数据
        typeList: [
          {
            name: '课程包',
            value: 1
          },
          {
            name: '课程',
            value: 2
          }
        ],
        categoryList: [
        ],
        courseList: [
        ]
      }
    },
    components: {
      'full-calendar': fullCalendar
    },
    mounted(){
      this.getStartDay();
      this.getCategoryList();
      this.getCalendarData();
    },
    methods: {
      saveMaterial: function() {
        // todo: 保存素材
      },
      saveSuggestion: function() {
        // todo: 保存建议
      },
      deleteMaterial: function() {
        const tipContent = this.$t('calendar.confirmDeleteMaterial') + '?'
        const tip = this.$t('tip')
        this.$confirm(tipContent, tip, {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning'
        })
          .then(async () => {
            // todo: 删除素材
          })
          .catch(_ => {})
      },
      addSuggestion: function () {
        this.addSuggestionDialogVisible = true
        // todo: 添加建议
      },
      addMaterial: function () {
        this.addMaterialDialogVisible = true
        // todo: 添加素材
        // 给materialForm赋值(月份,周期,大类,子类)
      },
      saveCategory: function () {
        // todo: 保存大类
      },
      saveMaterialType: function() {
        // todo: 保存素材类型设置
      },
      openAdd(parentId, isEdit) {
        this.materialTypeForm = _.cloneDeep(this.initMaterialTypeForm);
        this.editMaterialTypeVisible = true;
        this.isEditMaterialType = isEdit;
        this.materialTypeForm.parentId = parentId
      },
      async openEdit(data) {
        this.editMaterialTypeVisible = true;
        this.isEditMaterialType = true
        this.materialTypeForm.name = data.name || data.label;
        this.materialTypeForm.parentId = data.parentId;
      },
      append(data) {
        this.openAdd(data.id, false)
        // parentId是data.id
      },
      edit(data) {
        this.openEdit(data)
      },
      openDelete(node, data) {
        this.$confirm("确认删除吗？", "提示",{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(async() => {
            let res = await window.instance.post(courseUrl+"/systemCategory/deleteCategory/" + data.id)
            res = res.data
            if (res.code === 200) {
              await this.getData()
            }
          })
          .catch(_ => {})
      },
      renderContent(h, { node, data, store }) {
        return (
          <span class="custom-tree-node">
            <span>{node.label}</span>
            <span>
              <el-button size="mini" type="text" on-click={ () => this.append(data) }>新增</el-button>
              <el-button size="mini" type="text" on-click={ () => this.edit(data, true) }>编辑</el-button>
              <el-button size="mini" type="text" on-click={ () => this.openDelete(node, data) }>删除</el-button>
            </span>
          </span>);
      },
      setMaterialType: function() {
        // todo: 素材类型设置
        this.setMaterialTypeDialogVisible = true
      },
      async getCategoryList(){
        const params = {
          "parentId": 0,
        };
        let res = await window.instance.post(courseUrl+"/systemCategory/listCategoryAll", params);
        res = res.data;
        if (res.code === 200) {
          this.categoryList = res.data || [];
        }
      },
      async getCalendarData(){
        const params = {
          "startDate": this.currentStart
        };
        let res = await window.instance.post(courseUrl+"/courseCalendar/listCourseCalendar", params);
        res = res.data;
        if (res.code === 200) {
          const events = [];
          _.each(res.data, (ev) => {
            const date = ev.date.split(" ")[0];
            events.push(
              {
                title: ev.assignName,
                id: ev.courseCalendarId,
                start: date,
                end: date
              }
            );
          })
          this.fcEvents = events
        }
      },
      async searchList() {
        const urlCourse = '/course/listCourseByNameAndCategory/';
        const urlCourseCollection = '/coursePackage/listCoursePackageByName/';
        const paramsCourse = {
          categoryIds: this.filterData.categoryIds,
          courseName:  this.filterData.name
        };
        const paramsCourseCollection = {
          name: this.filterData.name
        };
        const searchUrl = this.filterData.type === 2 ? urlCourse : urlCourseCollection;
        const params = this.filterData.type === 2 ? paramsCourse : paramsCourseCollection;
        let res = await axios.post(courseUrl + searchUrl, params);
        res = res.data;
        if (res.code === 200) {
          console.log('res.data', res.data)
          if (this.filterData.type === 2){
            res.data.map(course => {course.name = course.courseName})
            this.courseList = res.data;
          } else {
            res.data.map(course => {course.name = course.name, course.courseId = course.id})
            this.courseList = res.data;
          }
        }
      },
      async assignToDate() {
        console.log('this.currentCourse', this.currentCourse);
        console.log('this.curDate', this.curDate);

        const params = {
          "assignId": this.currentCourse.courseId,
          "assignType": this.filterData.type,
          "date": this.curDate
        };
        let res = await axios.post(courseUrl + '/courseCalendar/saveCourseCalendar', params);
        res = res.data;
        if (res.code === 200) {
          console.log('res.data', res.data)
          this.getCalendarData()
        }
      },
      dayClick(a, b) {
        // const newDate = b.target.getAttribute("dateData");
        // console.log('newDate', newDate)
        this.curDate = this.format(a);
        // console.log('this.curData', this.curDate)
      },
      deleteClick(event, b) {
        this.$confirm("确认删除吗？", "提示",{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(async() => {
            let res = await axios.post(courseUrl + '/courseCalendar/deleteCourseCalendar/' + event.id);
            res = res.data
            if (res.code === 200) {
              await this.getCalendarData()
              this.$message.success(res.message)
            }else {
              // this.$message.warning(res.message)
            }
          })
          .catch(_ => {})
      },
      changeMonth(start, end, current) {
        this.currentStart = current;
        this.getCalendarData();
      },
      dragEnd(event, course){
        this.currentCourse = course;
        this.addEvent();
        this.assignToDate();
      },
      addEvent() {
        const newSchedule = {
          title : this.currentCourse.name,
          start : this.curDate,
          end : this.curDate,
        };
        this.fcEvents.push(newSchedule);
      },
      getStartDay() {
        var myDate = new Date();
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var m = tMonth + 1;
        if (m.toString().length == 1) {
          m = "0" + m;
        }
        this.currentStart = tYear +'-'+ m + '-01'
      },
      format(time){
        var y = time.getFullYear();
        var m = time.getMonth()+1;
        var d = time.getDate();
        return y+'-'+ m +'-'+ d;
      }
    }
  }
</script>

<style lang="sass" scoped>
  .calendar
    width: calc(100% - 40px)
    padding: 10px 20px
    .left
      width: 320px
      height: calc(100% - 70px)
      position: fixed
      border: 1px solid #DCDFE6
      border-radius: 4px
      background: #fff
      padding: 0 12px 0
      overflow: auto
      .tag
        font-size: 14px
        color: #606266
      ul
        width: 100%
        padding: 0
        margin: 10px 0 0 0
        font-size: 14px
        box-sizing: border-box
        li
          background: #5daf34
          color: #fff
          list-style: none
          padding: 0 6px
          line-height: 30px
          border-radius: 4px
          margin-bottom: 6px
    .right
      margin-left: 340px
      width: 100%
      max-width: 960px
      position: fixed
      height: calc(100% - 70px)
      overflow: auto
      background: #fff
      padding: 0 20px
  .categoryManageBox
    padding: 20px
    background: #fff
    .title
      color: #6F6F6F
      font-size: 26px
      font-weight: 600
      letter-spacing: 2px
      text-align: center
      margin-bottom: 30px
    .filter
      margin-top: 30px
    .label
      font-size: 14px
      color: #606266
    .table-container
      margin-top: 20px
  footer
    padding-top: 20px
    text-align: center

  .season-calendar-container
    width: 100%
    overflow: auto
  .season-calendar
    width: 3900px
    margin-top: 20px
    margin-bottom: 20px
  .month
    display: block
    border: 1px solid #DCDFE6
    ul
      display: flex
      flex-shrink: 0
      color: #303133
      li
        width: 1200px
        border-right: 1px solid #DCDFE6
        text-align: center
        padding: 6px
        &:last-of-type
          width: 1500px
          border-right: 0
  .week
    ul
      display: flex
      li
        width: 300px
        border: 1px solid #DCDFE6
        border-right: 0
        border-top: 0
        &:last-of-type
          border-right: 1px solid #DCDFE6
        .week-title
          text-align: center
          color: #303133
          border-bottom: 1px solid #DCDFE6
          padding: 6px
        .sub-week-title
          color: #606266
          border-bottom: 1px solid #DCDFE6
          padding: 6px
        .table-content
          display: flex
          flex-shrink: 0
          border-bottom: 1px solid #DCDFE6
          color: #606266
          .table-left
            width: 60px
            border-right: 1px solid #DCDFE6
            background: #f5f7fa
            padding: 6px
          .table-right
            width: 240px
            .material-content
              border-bottom: 1px solid #DCDFE6
              height: 90px
              &:last-of-type
                border: 0
              span
                display: block
                padding: 4px
              span.material
                background: #272727
                position: relative
                color: #fff
                i
                  position: absolute
                  right: 2px
                  top: 0
                  font-style: normal
                  font-size: 18px
        .bottom-table
          height: 150px
          .title
            color: #606266
          .add
            color: #606266
          span
            display: block
            padding: 4px
</style>

<style lang="sass">
.custom-tree-node
  flex: 1
  display: flex
  align-items: center
  justify-content: space-between
  font-size: 14px
  padding-right: 8px
</style>



// WEBPACK FOOTER //
// src/pages/wo/calendar.vue